<template>
    <v-data-table
        :options.sync= "pagination"
        :headers="headers"
        :items="items"
        :server-items-length="totalItems"
        :loading="loading"
        class="elevation-1">
            <template v-slot:top>
                <v-toolbar flat color="white">
                <v-toolbar-title>{{userViewTitle}}</v-toolbar-title>
                <v-divider
                    class="mx-4"
                    inset
                    vertical
                ></v-divider>
                <v-spacer></v-spacer>
                <v-dialog 
                    v-model="dialog" 
                    max-width="500px">
                    <template 
                        v-slot:activator="{ on, attrs }">
                        <v-btn
                            outlined
                            color="primary"
                            class="mb-2"
                            v-bind="attrs"
                            v-on="on"
                        >New User</v-btn>
                    </template>
                    <v-card>
                    <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                    </v-card-title>        
                    <v-card-text>
                        <v-container>
                        <v-row>
                            <v-col cols="12" sm="6" md="6">
                                <v-text-field v-model="editedItem.firstname" label="Firstname"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <v-text-field v-model="editedItem.lastname" label="Lastname"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="12" md="12">
                                <v-text-field v-model="editedItem.email" label="Email"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="12" md="12" v-if="action=='create'">
                                <v-text-field v-model="editedItem.password" label="Password"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="12" md="12">
                                <v-select
                                    v-model="editedItem.roles"
                                    :items="comboRoles"
                                    multiple
                                    item-text="name"
                                    item-value="code"
                                    label="Role"
                                ></v-select>
                            </v-col> 
                            <v-col cols="12" sm="12" md="12">
                                <v-select
                                    v-model="editedItem.authentication_type"
                                    :items="comboAuthenticatoinType"
                                    item-text="name"
                                    item-value="code"
                                    label="Authentication Type"
                                ></v-select>
                            </v-col>                          
                            <v-col cols="12" sm="6" md="6">
                                <v-text-field v-if="editedIndex > 0" v-model="editedItem.phone_number" label="Phone Number"></v-text-field>
                            </v-col>
                        </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" text @click="close" >Cancel</v-btn>
                        <v-btn color="primary" text @click="save">Save</v-btn>
                    </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-dialog v-model="confirmDialog" max-width="500px">
                    <v-card>
                        <v-card-title>
                            <span class="headline">Confirm New User</span>
                        </v-card-title>        
                        <v-card-text>
                            <v-container>
                            <v-row>
                                <v-col cols="12" sm="12" md="12">
                                    <v-select
                                        v-model="editedItem.roles"
                                        :items="comboRoles"
                                        multiple
                                        item-text="name"
                                        item-value="code"
                                        label="Role"
                                    ></v-select>
                                </v-col>
                                <span>On confirm, an email will be send to the user notifying the access credentials.</span>
                            </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" text @click="closeConfirmDialog" >Cancel</v-btn>
                            <v-btn color="primary" :disabled="editedItem.roles==null" text @click="confirmNewUser">Confirm</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                </v-toolbar>
            </template>
            <template v-slot:item="props">
                <tr>
                    <td class="row_class">{{props.item.lastname}}</td>
                    <td class="row_class">{{props.item.firstname}}</td>
                    <td class="row_class">{{props.item.email}}</td>
                    <td class="row_class">{{props.item.phone_number}}</td>
                    <td class="row_class">{{props.item.authentication_type}}</td>
                    <td class="row_class">
                        <v-chip v-for="role in props.item.roles">{{role}}</v-chip>
                    </td>
                    <td class="row_class">
                        <v-btn color="primary" text small @click="editItem(props.item)">edit</v-btn>                        
                        <v-btn v-if="props.item.status=='disable'" color="green" text small @click="enableItem(props.item)">enable</v-btn>
                        <v-btn v-if="props.item.status=='request' || props.item.status=='active'" color="error" text small @click="disableItem(props.item)">disable</v-btn>
                        <v-btn v-if="props.item.status=='request'" color="green" text small @click="confirmItem(props.item)">confirm</v-btn>                        
                        <v-btn v-if="props.item.status=='confirmed'"color="warning" text small @click="confirmItem(props.item)">resend mail</v-btn>
                    </td>
                </tr>
            </template>
    </v-data-table>
</template>
<script>
import Users from '@/api/users'
import validations from '@/modules/validations'
import Vue from 'vue'

export default {
    name: 'UserAdmin',    
    props: {
            filterStatus: {
                type: String,
                required: true
            }
        },
    data: () => ({
        action:"",
        totalItems: 0,
        items: [],
        comboRoles:[],
        comboAuthenticatoinType:['phone','email','generic'],
        loading: true,
        pagination: {},
        totalItems:0,
        dialog: false,
        requestList:{
            'pageNumber':1,
            'pageSize':10,
            'search':'',
            'userType': ''
        },
        confirmDialog: false,
        headers: [
            { text: 'Lastname', value: 'lastname', sortable:false  },
            { text: 'Firstname', value: 'firstname', sortable:false },
            { text: 'Email', value: 'email', sortable:false  },
            { text: 'Phone Number', value: 'phone_number', sortable:false  },            
            { text: 'Auth By', value: 'authentication_type', sortable:false  },
            { text: 'Role', value: 'role', sortable:false  },
            { text: 'Actions', value: 'actions', sortable:false  },
        ],
        editedIndex: -1,
        editedItem: {
            id:0,
            firstname: '',
            lastname: '',
            email: '',
            roles:'',
            authentication_type:'',
        },
        confirmedItem: {
            user_id:0,
            roles:''
        },
        defaultItem: {
            id:0,
            firstname: '',
            lastname: '',
            email: '',
            authentication_type:''
        },
    }),
    computed: {
      formTitle () {
        this.action = (this.editedIndex === -1 ? 'create' : 'edit')
        return this.editedIndex === -1 ? 'New User' : 'Edit User'
      },
      userViewTitle(){
        var title = ''
        switch(this.filterStatus){
            case 'active':
                title = 'Active Users'
                break
            case 'request':
                title = 'Requested Users'
                break
            case 'confirmed':
                title = 'Confirmed Users'
                break
            case 'disable':
                title = 'Disabled Users'
                break
        }
        return title
      }
    },
    watch: {
        pagination: {
            handler () {                
               this.getUsers()
               .then(data => {
                    this.items = data.items
                    this.totalItems = data.total
               })
            },
            deep: true
        },
        dialog(val) {
            val || this.close()
        },
        filterStatus(val){                           
            this.getUsers()
               .then(data => {
                    this.items = data.items
                    this.totalItems = data.total
               })
        }
    },
    created(){
        this.pagination
        this.getRoles()
    },
    methods: {
        confirmItem (item) {
            this.editedIndex = this.items.indexOf(item)
            this.confirmedItem.user_id = item.id
            this.confirmedItem.role = item.role
            this.confirmDialog = true
        },
        disableItem (item) {
            this.action = 'disable'        
			
            const index = this.items.indexOf(item)
            confirm('Are you sure you want to disable this user?') && this.items.splice(index, 1)
            return new Promise((resolve, reject) => {
                Users.disableUser(item.id).then(
                    data => {
                        Vue.notify({
                            group: 'general',
                            type: 'success',
                            text: 'The user was disabled.'
                        })
                    }
                )
            })            
           
        },
        editItem (item) {
            this.editedIndex = this.items.indexOf(item)
            this.editedItem = Object.assign({}, item)
            this.dialog = true            
        },
        enableItem (item) {
            this.action = 'enable'         
            const index = this.items.indexOf(item)
            confirm('Are you sure you want to enable this user?') && this.items.splice(index, 1)
            return new Promise((resolve, reject) => {
                Users.enableUser(item.id).then(
                    data => {
                        Vue.notify({
                            group: 'general',
                            type: 'success',
                            text: 'The user was enabled.'
                        })
                    }
                )
            })  
        },
        close () {
            this.dialog = false
            this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem)
            this.editedIndex = -1
            })
        },
        closeConfirmDialog () {
            this.confirmDialog = false
            this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem)
            this.editedIndex = -1
            })
        },        
        confirmNewUser () {
            this.confirmedItem.roles = this.editedItem.roles
            this.items.splice(this.editedIndex, 1)
            let localThis = this                
            return new Promise((resolve, reject) => {
                Users.confirmNewUser(localThis.confirmedItem).then(
                    data => {
                        Vue.notify({
                            group: 'general',
                            type: 'success',
                            text: 'An email was sent to the user notifying the access credentials.'
                        })                        
                        this.closeConfirmDialog()
                    }
                )
            })
        },
        save () {
            if (this.editedIndex > -1) {
                Object.assign(this.items[this.editedIndex], this.editedItem)
                let localThis = this                
                return new Promise((resolve, reject) => {
                    Users.editUser(localThis.editedItem).then(
                        this.close()
                    )
                }) 
            } else {
                this.items.push(this.editedItem)                
                let localThis = this                
                return new Promise((resolve, reject) => {
                    Users.createAdminAccount(localThis.editedItem).then(
                        this.close()
                    )
                }) 
            }
            this.close()
        },
        getUsers () {
            let localThis = this
            this.loading = true
            let items =[]
            localThis.requestList.userType = this.filterStatus
            localThis.requestList.pageSize = this.pagination.itemsPerPage
            localThis.requestList.pageNumber = this.pagination.page
            return new Promise((resolve, reject) => {
                Users.getUsers(localThis.requestList).then(
                    data => {
                        items = data.results
                        const total = data.totalItems                        
                        setTimeout(() => {
                            localThis.loading = false;
                            resolve({
                                items,
                                total
                            })
                            }, 1000
                        )
                    }
                )                
            })
        },
        getRoles () {
            let localThis = this            
            return new Promise((resolve, reject) => {
                Users.getRoles().then(
                    data => {
                        localThis.comboRoles = data;                        
                    }
                )                
            })
        }
    }
}
</script>
<style scoped>
    .menu_items{
        font-size: smaller !important ;
    }
    .title{
        font-size: medium !important;
        color: #003498 !important;
    }
    .v-btn{
        text-transform: none !important;
    }
    .row_class{
        height: 19px !important;
        font-size: small !important;
    }
    .v-chip.v-size--default {
    border-radius: 16px;
    font-size: 12px;
    height: 22px;
}
</style>